export default __webpack_public_path__ + "assets/b9c9dc0820ef6e7fcac62e4b9a175b46.woff2";